export class EconomicAnalysis {
  averagingMethodology: string;
  id: number;
  jurisdiction: string;
  statisticalMethodology: string;
  yearsOfData: number;
}
